import Vue from 'vue'
import Vuex from 'vuex'
import moment from "moment";
import themeConfig from '@/../themeConfig.js'
import { encode, decode } from 'js-base64';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: window.localStorage.getItem('USER_TOKEN'),
    //样式
    theme: themeConfig.theme,
    isSidebarActive: false,
    isSidebarReduced: themeConfig.sidebarCollapsed,
    sidebarWidth: "default",
    themeColor: themeConfig.themeColor,

    // Calendar Events
    calendarEvents: [{
      title: "test",
      allDay: true,
      start: moment(),
      end: moment().add(1, "d")
    }],

    // Email States
    //emails: mails,
    filtered_mail: "Inbox",

    //查询详细信息的所有ID
    tpIndexId: 0,
    sysMode: 1,  //1 等于机器人客户    2 新的客户中心入口
    miniPro: 2,  // 1 小程序版本    2 网页公众号版本
    //base: 'http://192.168.1.7',
    //base: 'http://mobile.dlyihu.com',
    //aHR0cDovLzM5LjEwNS4wLjExNg==
    //base: encode('aHR0cDovLzM5LjEwNS4wLjExNg==')
    //base: decode('aHR0cDovL2FpbS5zaW5kZG8uY29t')
    //base: 'http://m.call8.cc'
    //base: 'http://192.168.1.16',
    //base: 'http://localhost',
    base: ''
  },
  mutations: {
    // 登录成功后调用此方法
    // 初始化本地用户详细数据
    INIT_USER_INFO (state, userInfo) {
      state.userInfo = userInfo
      window.sessionStorage.setItem('USER_INFO', userInfo)
      state.token = userInfo.token
      window.sessionStorage.setItem('USER_TOKEN', userInfo.token)
    },
    //
//This is for Sidbar trigger in mobile
    IS_SIDEBAR_ACTIVE(state, value) {
      state.isSidebarActive = value;
    },
    //This is for Sidebar toggle in desktop
    TOGGLE_REDUCE_SIDEBAR(state, val) {
      state.isSidebarReduced = val;
    },
    //This is for Themeset
    SET_THEME(state, val) {
      state.theme = val;
    },
    //This is for Theme color
    SET_THEME_COLOR(state, val) {
      state.themeColor = val;
    },
    SET_SIDEBAR_WIDTH(state, width) {
      state.sidebarWidth = width;
    },
    // Add Calendar event
    ADD_CALENDAR_EVENT(state, event) {
      const newEvent = Object.assign({}, event);
      state.calendarEvents.push(newEvent);
    },
    // Filter emails
    FILTERED_MAIL(state, filterCategory) {
      state.filtered_mail = filterCategory
    },
  },
  actions: {
    updateSidebarWidth({ commit }, width) {
      commit('SET_SIDEBAR_WIDTH', width);
    },
    //Calendar Action
    addCalendarEvent({ commit }, event) {
      commit('ADD_CALENDAR_EVENT', event);
    },

    // Email Action
    filteredMail({ commit }, filterCategory){
      commit('FILTERED_MAIL', filterCategory)
    },
  },

  getters:{
    // Get Filtered Email
    getFilteredMails: state => state.emails.filter((email) => {
      if (state.filtered_mail == 'Inbox') return email.mail_type == "inbox";
      if (state.filtered_mail == 'Spam') return email.mail_type == "spam";
      if (state.filtered_mail == 'Draft') return email.mail_type == "draft";
      if (state.filtered_mail == 'Sent') return email.mail_type == "sent";
    }),
    getCurrentMail: state => (emailId) => state.emails.filter((email) => email.id == emailId)[0],
    getInboxCount: state => state.emails.filter((email) => email.mail_type == 'inbox').length,
  }
})
export default store



// WEBPACK FOOTER //
// ./src/stores/index.js